var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDbf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e0"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d9d7ca"
    },
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e96360"
    },
    d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M22.947,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C18.95,52.984,18.754,53,18.627,53h-3.814V42.924h3.035 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C22.842,46.494,22.947,47.08,22.947,47.682z M18.08,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M30.098,47.695c0.209,0.027,0.433,0.096,0.67,0.205c0.237,0.109,0.458,0.265,0.663,0.465 s0.376,0.444,0.513,0.731s0.205,0.617,0.205,0.991c0,0.456-0.068,0.848-0.205,1.176s-0.308,0.6-0.513,0.813 s-0.429,0.383-0.67,0.506c-0.242,0.123-0.474,0.217-0.697,0.28c-0.224,0.063-0.422,0.103-0.595,0.116 C29.295,52.993,29.182,53,29.127,53H25.34V42.924h2.898c0.428,0,0.843,0.05,1.244,0.15c0.401,0.101,0.756,0.26,1.066,0.479 c0.31,0.219,0.556,0.504,0.738,0.854c0.182,0.351,0.273,0.768,0.273,1.251c0,0.282-0.046,0.54-0.137,0.772 c-0.091,0.232-0.205,0.436-0.342,0.608s-0.294,0.316-0.472,0.431S30.262,47.659,30.098,47.695z M28.197,47.23 c0.2,0,0.405-0.005,0.615-0.014c0.209-0.009,0.405-0.06,0.588-0.15c0.182-0.091,0.33-0.246,0.444-0.465 c0.114-0.219,0.171-0.533,0.171-0.943c0-0.164-0.023-0.335-0.068-0.513c-0.046-0.178-0.137-0.34-0.273-0.485 s-0.333-0.265-0.588-0.355c-0.255-0.091-0.593-0.137-1.012-0.137H26.98v3.063h0.068H28.197z M29.031,51.797 c0.483,0,0.861-0.155,1.135-0.465s0.41-0.725,0.41-1.244c0-0.492-0.142-0.907-0.424-1.244c-0.283-0.337-0.697-0.506-1.244-0.506 H26.98v3.459H29.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M36.168,44.168v3.172h4.211v1.121h-4.211V53H34.5V42.924h6.303v1.244H36.168z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M24.5,16v-4h-12v4v2v2v2v2v2v2v2v4h10h2h21v-4v-2v-2v-2v-2v-2v-4H24.5z M14.5,14h8v2h-8V14z M14.5,18h8v2h-8V18z M14.5,22h8v2h-8V22z M14.5,26h8v2h-8V26z M22.5,32h-8v-2h8V32z M43.5,32h-19v-2h19V32z M43.5,28h-19v-2h19V28 z M43.5,24h-19v-2h19V24z M24.5,20v-2h19v2H24.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbf);
export default __webpack_public_path__ + "static/media/dbf.1070be17e909945ac4407180463c9271.svg";
export { ForwardRef as ReactComponent };